import { BootstrapURLKeys, MapOptions } from "google-map-react";
import dynamic from "next/dynamic";
import { useInView } from "react-intersection-observer";

const GoogleMapReact = dynamic(() => import("google-map-react"), {
  ssr: false,
});

const MAP_ID = "15d0f58c16dbbb99";

const Map: React.FC<MapProps> = ({
  apiKey,
  className,
  children,
  location: { latitude, longitude },
}) => {
  const { ref, inView } = useInView({
    rootMargin: "200px",
    triggerOnce: true,
  });

  if (!inView) {
    return <div className={className} ref={ref}></div>;
  }

  const keys: BootstrapURLKeys & { mapIds: string[] } = {
    key: apiKey,
    mapIds: [MAP_ID],
  };

  const options: MapOptions & { mapId: string } = {
    mapId: MAP_ID,
    styles: undefined,
  };

  return (
    <div ref={ref} className={className}>
      <GoogleMapReact
        bootstrapURLKeys={keys}
        options={options}
        defaultCenter={{ lat: latitude, lng: longitude }}
        defaultZoom={15}
        onGoogleApiLoaded={({ map }) => {
          if (window && window.innerWidth > 1024) {
            map.panBy(300, 0);
          }
        }}
      >
        {children}
      </GoogleMapReact>
    </div>
  );
};

// Avoids TS errors caused by unknown lat and lng props required by google-map-react
export const MapMarker: React.FC<MapMakerProps> = ({ children, className }) => (
  <div className={className}>{children}</div>
);

type MapProps = {
  apiKey: string;
  className?: string;
  location: {
    latitude: number;
    longitude: number;
  };
};

type MapMakerProps = {
  className?: string;
  lat: number;
  lng: number;
};

export default Map;
